import DeleteAlert from "./DeleteAlert";
import UpdateAlert from "./UpdateAlert"
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import Box from "@mui/material/Box";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import SendAlertModal from "./sending";

export default function AccountMenu({ id, name, data, getAllHotels, regions }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        sessionStorage.setItem("hotelname", name);
        setAnchorEl(event.currentTarget);
    };
    const navigate = useNavigate();
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Box>
                <Tooltip title="Account settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ textAlign: "center" }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                    >
                        <Avatar sx={{ width: 32, height: 32 }}>A</Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": { width: 32, height: 32, ml: -0.5, mr: 1 },
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                <MenuItem>
                <Button variant="contained"  onClick={()=>{navigate(`/update-alerts/${id}`)}}>Update alert</Button>
                </MenuItem>
                <MenuItem>
                    <SendAlertModal data={data} id={id} getAllHotels={getAllHotels} handleMenuClose={handleClose} regions={regions} />
                </MenuItem>
                <MenuItem>
                    <DeleteAlert data={data} id={id} getAllHotels={getAllHotels} handleMenuClose={handleClose} regions={regions} />
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
